export enum SmartLibraryApplication {
    General = -1,
    ManagementConsole = 1,
    LoanStation = 2,
    CirculationAssistant = 3,
    SortAssistant = 4,
    Services = 7,
    RetrospectiveTagging = 8,
    AlarmViewer = 10,
    SingularTags = 12,
    TagUtility = 14,
    OverprintedTags = 16,
    ServicesConsole = 18,
    SecurityGatesDemoApp = 25,
    SmartReturnsDemoApp = 26,
    LmsSimulatorFrontend = 27,
    Kiosk = 28,
    SelfLoanStationDiagnostics = 29,
    ShelfScannerSync = 30,
    WebService = 31,
    SecurityGatesDiagnostics = 32,
    AnytimeLibrary = 33,
    Sorter = 34,
    ReturnShelf = 35,
    Solarflare = 36,
    ReturnShelfDashboard = 37
}

export const SmartLibraryApplicationLabel = new Map<SmartLibraryApplication, string>([
    [SmartLibraryApplication.General, 'General'],
    [SmartLibraryApplication.ManagementConsole, 'Management Console'],
    [SmartLibraryApplication.LoanStation, 'Loan Station (Classic)'],
    [SmartLibraryApplication.CirculationAssistant, 'Circulation Assistant'],
    [SmartLibraryApplication.SortAssistant, 'Sort Assistant'],
    [SmartLibraryApplication.Services, 'Services'],
    [SmartLibraryApplication.RetrospectiveTagging, 'Retrospective Encoding'],
    [SmartLibraryApplication.AlarmViewer , 'Alarm Viewer'],
    [SmartLibraryApplication.SingularTags , 'Singular Tags'],
    [SmartLibraryApplication.TagUtility , 'Tag Utility'],
    [SmartLibraryApplication.OverprintedTags , 'Overprinted Tags'],
    [SmartLibraryApplication.ServicesConsole , 'Services Console'],
    [SmartLibraryApplication.SecurityGatesDemoApp , 'Security Gates Demo App'],
    [SmartLibraryApplication.SmartReturnsDemoApp , 'Smart Returns Demo App'],
    [SmartLibraryApplication.LmsSimulatorFrontend , 'LMS Simulator Front-End'],
    [SmartLibraryApplication.Kiosk , 'Charge-Up Station'],
    [SmartLibraryApplication.SelfLoanStationDiagnostics , 'Self Loan Station Diagnostics'],
    [SmartLibraryApplication.ShelfScannerSync , 'Shelf Scanner Sync'],
    [SmartLibraryApplication.WebService , 'Web Service'],
    [SmartLibraryApplication.SecurityGatesDiagnostics , 'Security Gates Diagnostics'],
    [SmartLibraryApplication.AnytimeLibrary , 'Anytime Library'],
    [SmartLibraryApplication.Sorter , 'Sorter'],
    [SmartLibraryApplication.ReturnShelf , 'Return Shelf'],
    [SmartLibraryApplication.Solarflare , 'Loan Station (Envoy)'],
    [SmartLibraryApplication.ReturnShelfDashboard, 'Return Shelf Dashboard']
]);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/enums/smart-library-application.enum.ts